// @ts-nocheck
import { Plugin } from '/data1/jenkins/workspace/aplus_tiger_my_level_20230614092632_tiger-platform_udb_my_level_115719_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu',],
});

export { plugin };
